import React, { useState } from 'react'

import { UStoreProvider } from '@ustore/core'
import { t } from '$themelocalization'

import Slot from '../components/widgets/Slot'
import Layout from '../components/layout'
import PromoSection from '../components/home/PromoSection'
import urlGenerator from '$ustoreinternal/services/urlGenerator'
import { decodeStringForURL } from '$ustoreinternal/services/utils'
import './Home.scss'

import promaMappeIcon from '$assets/icons/promo-mappe.svg'
import setzlingIcon from '$assets/icons/setzling.svg'
import kreislaufIcon from '$assets/icons/kreislauf.svg'
import stromIcon from '$assets/icons/strom.svg'
import familieIcon from '$assets/icons/familie.svg'
import pflanzeGif from '$assets/gif/Pflanze.gif'
import kreislaufGif from '$assets/gif/Kreislauf.gif'
import blitzGif from '$assets/gif/blitz.gif'
import familieGif from '$assets/gif/familie.gif'

const ECO_CARDS = [
  { icon: setzlingIcon, gif: pflanzeGif, titleKey: 'Home.Eco.Materialgesund.Title', textKey: 'Home.Eco.Materialgesund.Text' },
  { icon: kreislaufIcon, gif: kreislaufGif, titleKey: 'Home.Eco.Kreislauf.Title', textKey: 'Home.Eco.Kreislauf.Text' },
  { icon: stromIcon, gif: blitzGif, titleKey: 'Home.Eco.Strom.Title', textKey: 'Home.Eco.Strom.Text' },
  { icon: familieIcon, gif: familieGif, titleKey: 'Home.Eco.Familie.Title', textKey: 'Home.Eco.Familie.Text' },
]

const TESTIMONIAL_KEYS = [
  { nameKey: 'Home.Testimonial.1.Name', textKey: 'Home.Testimonial.1.Text' },
  { nameKey: 'Home.Testimonial.2.Name', textKey: 'Home.Testimonial.2.Text' },
  { nameKey: 'Home.Testimonial.3.Name', textKey: 'Home.Testimonial.3.Text' },
]

const Home = (props) => {
  const { customState: { categoriesTree } } = props
  const [activeTab, setActiveTab] = useState(0)
  const [promoVisible, setPromoVisible] = useState(true)

  const closePromoBar = () => {
    setPromoVisible(false)
  }

  if (!props.state) {
    return null
  }

  const tabs = categoriesTree || []
  const activeNode = tabs[activeTab]
  const subCategories = activeNode?.SubCategories || []

  return (
    <Layout {...props} className="home">

      {/* Promo Bar */}
      {promoVisible && (
        <div className="home-promo-bar-sticky">
        <div className="home-promo-bar" id="promoBar">
          <img src={promaMappeIcon} alt="" className="home-promo-bar__icon" />
          <div className="home-promo-bar__text">
            <strong>{t('Home.PromoBar.Title')}</strong>
            <span>{t('Home.PromoBar.Text')}</span>
          </div>
          <a className="home-promo-bar__cta" href={t('Home.PromoBar.URL')}>{t('Home.PromoBar.CTA')}</a>
          <button className="home-promo-bar__close" onClick={closePromoBar} title="Schliessen">✕</button>
        </div>
        </div>
      )}

      {/* Hero */}
      <div className="home-hero">
        <div className="home-hero__inner">
          <h1 className="home-hero__title">Pure<span className="home-hero__print">Print</span></h1>
          <p className="home-hero__subtitle">By Vögeli AG</p>
          <p className="home-hero__slogan">{t('Home.Hero.Slogan')}</p>
        </div>
      </div>

      {/* Products label */}
      {/*<p className="home-products-heading">{t('Home.Products.Heading')}</p>*/}

      {/* Tabs */}
      {tabs.length > 0 && (
        <section className="home-tabs-section">
          <div className="home-tabs">
            {tabs.map((node, index) => (
              <button
                key={node.Category.ID}
                className={`home-tab ${index === activeTab ? 'home-tab--active' : ''} ${index % 2 === 0 ? 'home-tab--green' : 'home-tab--grey'}`}
                onClick={() => setActiveTab(index)}
              >
                {node.Category.ImageUrl && (
                  <img src={node.Category.ImageUrl} alt={node.Category.Name} width="150" height="150" />
                )}
                <p>{node.Category.Name}</p>
              </button>
            ))}
          </div>

          {activeNode && (
            <div className="home-tab-content">
              {/*<h4 className="home-tab-content__title">{activeNode.Category.Name}</h4>*/}
              <div className="home-tab-products">
                {subCategories.map((subNode) => {
                  const cat = subNode.Category
                  const url = urlGenerator.get({ page: 'category', id: cat.FriendlyID, name: decodeStringForURL(cat.Name) })
                  return (
                    <a key={cat.ID} className="home-product-tile" href={url}>
                      {cat.ImageUrl && (
                        <img src={cat.ImageUrl} alt={cat.Name} className="home-product-tile__img" />
                      )}
                      <p className="home-product-label">{cat.Name}</p>
                    </a>
                  )
                })}
              </div>
            </div>
          )}
        </section>
      )}

      <PromoSection />


        {/* Green claim 1 */}
      <section className="home-green-section">
        <div className="home-wrapper">
          <div className="home-col">
            <h2>{t('Home.Claim1.Title')}</h2>
          </div>
          <div className="home-col">
            <p className="home-green-text">{t('Home.Claim1.Text')}</p>
          </div>
        </div>
      </section>

      {/* Eco cards */}
      <section className="home-eco-section">
        <div className="home-wrapper home-eco-cards">
          {ECO_CARDS.map(({ icon, gif, titleKey, textKey }) => (
            <div key={titleKey} className="home-eco-card">
              <div className="home-eco-inner">
                <img src={icon} alt={t(titleKey)} width="150" height="100" className="home-eco-icon" />
                <img src={gif} alt={t(titleKey)} width="150" height="100" className="home-eco-gif" />
                <p className="home-eco-title">{t(titleKey)}</p>
                <p className="home-eco-text">{t(textKey)}</p>
                <a className="home-eco-btn" href={t('Home.Eco.Button.URL')} target="_blank" rel="noreferrer">{t('Home.Eco.Button')}</a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Green claim 2 */}
      <section className="home-green-section">
        <div className="home-wrapper">
          <div className="home-col">
            <h2>{t('Home.Claim2.Title')}</h2>
          </div>
          <div className="home-col">
            <p className="home-green-text">{t('Home.Claim2.Text')}</p>
          </div>
        </div>
      </section>

      {/* Video */}
      <section className="home-video-section">
        <div className="home-wrapper">
          <h2 className="home-c2c-title">{t('Home.C2C.Title')}</h2>
          <p className="home-c2c-text">{t('Home.C2C.Text')}</p>
          <div className="home-video">
            <iframe
              src={`https://www.youtube.com/embed/${t('Home.Video.ID')}?autoplay=1&mute=1`}
              title="Cradle to Cradle"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="home-testimonials">
        <h2 className="home-testimonials__title">{t('Home.Testimonials.Title')}</h2>
        <div className="home-testimonials__line" />
        <div className="home-testimonials__google">
          <a
            href="https://www.google.com/search?q=google+reviews+V%C3%B6geli+AG"
            target="_blank"
            rel="noreferrer"
          >
            {t('Home.Testimonials.Google')}
          </a>
        </div>
        <div className="home-wrapper">
          {TESTIMONIAL_KEYS.map(({ nameKey, textKey }) => (
            <div key={nameKey} className="home-testimonial">
              <p className="home-testimonial__name">{t(nameKey)}</p>
              <div className="home-testimonial__stars">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="fa fa-star" />
                ))}
              </div>
              <p>{t(textKey)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* HubSpot */}
      <script type="text/javascript" id="hs-script-loader" async defer src="//js-eu1.hs-scripts.com/25288491.js" />
      <Slot name="homepage_bottom" />
    </Layout>
  )
}

export default Home

function clearCustomState() {
  UStoreProvider.state.customState.delete('homeFeaturedProducts')
  UStoreProvider.state.customState.delete('homeFeaturedCategory')
  UStoreProvider.state.customState.delete('currentProduct')
  UStoreProvider.state.customState.delete('currentOrderItem')
  UStoreProvider.state.customState.delete('currentOrderItemId')
  UStoreProvider.state.customState.delete('currentOrderItemPriceModel')
  UStoreProvider.state.customState.delete('lastOrder')
  UStoreProvider.state.customState.delete('currentProductThumbnails')
}
